define('customPlugins/utils',['lodash', 'knockout'], function(_, ko) {
    'use strict';
    var utils = {};
    utils.treeWalk = treeWalk;
    utils.treeWalkBFS = treeWalkBFS;
    utils.events = {
        ATN_ALTERED: 'atn-altered',
    };

    utils.applicationRoot = '#applicationHost';
    // utils.kendoGridElementsList = ['atnKendoComboBox', 'atnKendoNumericTextBox', 'kendoComboBox', 'kendoNumericTextBox', 'kendoDropDownList', 'kendoMultiSelect'];
    utils.viewportDimension = ko.observable({
        height: window.innerHeight,
        width: window.innerWidth
    });
    /**
     * Remove an element and provide a function that inserts it into its original position
     * @param element {Element} The element to be temporarily removed
     * @return {Function} A function that inserts the element into its original position
     **/
    utils.removeToInsertLater = function(element) {
        var parentNode = element.parentNode;
        var nextSibling = element.nextSibling;
        parentNode.removeChild(element);
        return function() {
            if (nextSibling) {
                parentNode.insertBefore(element, nextSibling);
            } else {
                parentNode.appendChild(element);
            }
        };
    };

    /**
    * [isInternetExplorer  confirms if the current browser is Internet Explorer]
    * @return {[Boolean]} [Returns the true if this is Internet Explorer, 
    * else false, indicating the use of another browser]
    */
    utils.isInternetExplorer = function() {
        var isIE = false; //Return value assumes failure.
        if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
            isIE = true;
        }
        return isIE;
    };


    /**
    * [isSafari  confirms if this is the Safari browser]
    * @return {[Boolean]} [Returns true if this is Safari,
    * else false, indicating the use of another browser]
    */
    utils.isSafari = function() {
        var isSafari = false; //Return value assumes failure.
        if (navigator.userAgent.toLowerCase().indexOf('safari') !== -1) {
            isSafari = true;
        }
        return isSafari;
    };

    /**
     * function to regexp literals
     * @param  {string} str string to be escaped
     * @return {string}     regexp escaped string
     */
    utils.escapeRegExp = function(str) {
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
    };

    /**
     * function to capture mousewheel
     * @param  {DOMElement} element    element on which mousewheel has to be attached
     * @param  {Function} listener     function to listen to mousewheel
     * @param  {Boolean} useCapture    to capture event or not
     * @return {undefined}
     */
    utils.attachMousewheel = function(element, listener, useCapture) {
        if (element.addEventListener) {
            element.addEventListener('wheel', onScroll, useCapture);
            element.addEventListener('mousewheel', onScroll, useCapture);
            element.addEventListener('DOMMouseScroll', onScroll, useCapture);
        } else {
            element.attachEvent('onmousewheel', onScroll);
        }

        function onScroll(e) {
            e.atnDirection = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
            /* jshint validthis:true */
            listener.apply(this, [e]);
            e.stopPropagation();
        }
    };

    /**
     * function to generate function to create unqiue Ids
     * @return {Function} function to generate uuid for given index
     */
    utils.getUniqueIdGenerator = function() {
        var INIT_MIN = Math.pow(10, 13);
        return function(index) {
            return _.now().toString(36) + (INIT_MIN + index).toString(36);
        };
    };

    /**
     * to attach the dragging on a given element
     * @param  {DOMElement} element          element on which mousewheel has to be attached
     * @param  {Object<Function>} actions    Object containing map of actions to take while
     *                                       dragging
     * @return {undefined}
     */
    utils.attachDrag = function(element, actions) {
        var actual = {},
            previous = {},
            current = {},
            noop = _.noop;

        actions.onStart = actions.onStart || noop;
        actions.onDrag = actions.onDrag || noop;
        actions.onStop = actions.onStop || noop;

        element.addEventListener('mousedown', onMousedown, false);
        document.addEventListener('mouseup', onMouseup, false);

        function onMousedown(event) {
            previous.x = current.x = actual.x = event.screenX;
            previous.y = current.y = actual.y = event.screenY;
            document.addEventListener('mousemove', onMousemove, false);
            actions.onStart(element, current);
            event.preventDefault();
        }

        function onMousemove(event) {
            previous.x = current.x;
            previous.y = current.y;
            current.x = event.screenX;
            current.y = event.screenY;
            actions.onDrag(element, actual, previous, current);
        }

        function onMouseup() {
            document.removeEventListener('mousemove', onMousemove, false);
            actions.onStop(element, current);
        }
    };

    /**
     * function to perform unitary method
     *
     * The unitary method is a technique in elementary algebra
     * for solving a class of problems in variation. It consists
     * of altering one of the variables to a single unit, i.e. 1,
     * and then performing the operation necessary to alter it to
     * the desired value
     *
     * Here we use the equestion,
     *
     * total value of current unit    total value of other unit
     * --------------------------- =  -------------------------
     * number of current unit         number of other units
     *
     * @param  {Number} otherNum  total value of other unit
     * @param  {Number} otherDeno number of other units
     * @param  {Number} selfDeno  number of current unit
     * @return {Number}           total value of current unit
     */
    utils.unitary = function(otherNum, otherDeno, selfDeno) {
        return (otherNum * selfDeno) / otherDeno;
    };

    utils.checkChartHasData = function(jqChart, isPieChart) {
        //  fetching dataSeries in caes of Pie and other charts
        var dataSeries = (isPieChart) ? jqChart.series[0].data : jqChart.series;
        //  check all non-pie series are visible
        return _.reduce(dataSeries,
            function(result, series) {
                return result || (series.visible && 'pie' !== series.type);
            },
            false
        );
    };

    //  Visit: https://developer.mozilla.org/en-US/docs/Web/API/Console.time
    console.time = console.time || _.noop;
    console.timeEnd = console.timeEnd || _.noop;

    window.onresize = function() {
        _.defer(utils.viewportDimension, {
            height: window.innerHeight,
            width: window.innerWidth
        });
    };


    return utils;

    function treeWalk(node, getChildren, preAction, postAction, parent) {
        if (_.isFunction(preAction)) {
            preAction(node, parent);
        }

        var children = getChildren(node);
        if (_.isArray(children)) {
            _.forEach(children, function(child) {
                treeWalk(child, getChildren, preAction, postAction, node);
            });
        }
        if (_.isFunction(postAction)) {
            postAction(node, parent);
        }
    }

    /**
     * [treeWalkBFS description]
     * @param   node represents current node under process
     * @param   preAction  represents actions to be performed on a node before processing its child nodes
     * @param   postAction represents actions to be performed on a node after all of its children are processed
     * @param   parent represents immediate parent of node under process
     *
     * param available: head, tail, parent
     * 
     * @return
     */

    function treeWalkBFS(node, preAction, postAction, queue) {
        var i;

        //add the root node to the queue
        queue.push({
            child: node,
            parent: null
        });
        for (i = 0; i < queue.length; i++) {
            preAction(queue[i].child, queue[i].parent);
            addParentsAndEnqueueChildren(queue[i].child, queue);
        }
        for (i = queue.length - 1; i >= 0; i--) {
            postAction(queue[i].child, queue[i].parent);
        }
    }

    /**
     * Function to add parent property to all children of node and add chidren to queue
     * @param   node represents location in the tree whose children will be added to queue for further processing
     * @param   queue, passed by reference, contains children of all nodes traversed so far.
     * @return
     */
    function addParentsAndEnqueueChildren(node, queue) {
        var length = node.children.length;
        for (var i = 0; i < length; i++) {
            // node.children[i].parent = node;
            // queue.push(node.children[i]);
            queue.push({
                child: node.children[i],
                parent: node
            });
        }

    }

});
